export interface InstagramAdvanceSetting {
  desktop?: AdvanceSettingDevice;
  mobile?: AdvanceSettingDevice;
}

export interface AdvanceSettingDevice {
  headerElement: HeaderElementSetting;
  popupSetting: PopupSetting;
  productTagSetting: ProductTagSetting;
  feedContentSetting: FeedContentSetting;
}

export enum HeaderAlignment {
  Left = "left",
  Center = "center",
  Right = "right"
}
export interface FeedContentSetting {
  roundedCorner: number;
  roudedCornerLoadmore?: number;
  postSpacing: number;
  autoPlayVideo?: boolean;
  textSize?: number;
  mediaSize?: string;
  postSpacingHorizontal?: number;
  postSpacingVertical?: number;
  elementPlacementRelativeMedia?: string;
  postElement?: PostElement;
  contentType: string;
  displayOrder: string;
  autoMovingSlider: boolean;
  movingSpeed: number;
}

export enum InstagramDisplayOrder {
  NewestToOldest = "NewestToOldest",
  OldestToNewest = "OldestToNewest"
}
export enum InstagramFeedContentType{
  All = "All",
  OnlyVideos = "OnlyVideos",
  OnlyImages = "OnlyImages"
}

export enum ElementPlacementRelativeMedia {
  Inside = "Inside",
  Outside = "Outside"
}

export enum MediaSize {
  Vertical = "Vertical",
  Square = "Square",
  Horizontal = "Horizontal"
}
export const MediaSizeAspec = {
  Vertical: "9/16",
  Square: "9/9",
  Horizontal: "4/3"
};
export interface PostElement {
  icon?: boolean;
  likeAndCommentCount?: boolean;
  caption?: boolean;
}
export interface HeaderElementSetting {
  profilePicture: boolean;
  postsCount: boolean;
  username: boolean;
  followersCount: boolean;
  followButton: boolean;
  followingCount: boolean;
  followButtonBackground: string;
  headerAlignment?: string;
  followButtonRoundCorner?: number;
}

export interface PopupSetting {
  onPostClick: string;
  enableUserProfile: string;
}

export interface ProductTagSetting {
  onClickAction: string;
  ctaButtonText: string;
}

export enum OnPostClick {
  OpenDetailPopup = "OpenDetailPopup",
  OpenMinimalPopup = "OpenMinimalPopup",
  OpenOriginal = "OpenOriginal",
  Donothing = "Donothing"
}

export enum EnableUserProfile {
  OpenProfileInNewTab = "OpenProfileInNewTab",
  OpenProfileInSameTab = "OpenProfileInSameTab"
}

export enum OnClickAction {
  RedirectToShopifyStore = "RedirectToShopifyStore",
  PurchaseDirect = "PurchaseDirect"
}
